// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rp4I","colBig":"styles_colBig__3TSH6","colSmall":"styles_colSmall__1PD6Y"};